import request from './request'
import type { ChecklistItem } from './checklist'

export interface ChecklistDetailResponse {
  code: number
  msg: string
  data: ChecklistItem
}

export interface ChecklistUpdateParams {
  id: number
  type?: string
  item_name?: string
  item_name_zh?: string
  duration_minutes?: number
  seasons?: string[]
  section?: string
  frequency?: string
  photo_required?: number
  follow_up_needed?: number
  plan_includes_follow_up_care?: string[]
  plan_values?: {
    essential_care: number
    enhanced_care: number
    premium_care: number
  }
  description?: string
  description_zh?: string
  icon_url?: string
  sort?: number
  status?: number
}

export interface ChecklistUpdateResponse {
  code: number
  msg: string
  data?: ChecklistItem
}

export function getChecklistDetail(id: string | number): Promise<ChecklistDetailResponse> {
  return request.post('/api/admin/checklist/detail', { id })
}

export function updateChecklist(params: ChecklistUpdateParams): Promise<ChecklistUpdateResponse> {
  return request.post('/api/admin/checklist/update', params)
}
